import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

/**
 * API slice for field help AI assistant
 */
export const fieldHelpAiSlice = createApi({
  reducerPath: 'fieldHelpAi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: process.env.REACT_APP_BACKEND_URL,
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
      // Get the token from auth state
      const token = getState().auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: ['FieldHelp'],
  endpoints: (builder) => ({
    // Get AI help for a specific field
    getFieldAiHelp: builder.mutation({
      query: (data) => ({
        url: '/field-help',
        method: 'POST',
        body: data
      })
    })
  })
});

export const {
  useGetFieldAiHelpMutation
} = fieldHelpAiSlice;
